// extracted by mini-css-extract-plugin
module.exports =  {"root":"P2ZMPZGK3ghWDW1FPMgq","addVerticalGap":"kVmoxWSazgq8rrjWPD9D","content":"s40i_lWszlTLFFDXbrGA","description":"wfd2W7EmDpUrLdMb1_Hw"};